import { BasicObject, MousePointer } from './basicObject';

// Tracks whether there is currently anything 'floating' on top of everything else.
// Except... not including dialogs. So really, only popup menus painted on the canvas.
class FloaterManager {
  panel?: BasicObject;
  preserveOnClick = false;

  paint(ctx: CanvasRenderingContext2D): void {
    this.panel?.paint(ctx);
  }

  mouseDown(x: number, y: number, paintCanvas: () => void): boolean {
    if (!this.panel) return false;
    this.panel.mouseDown(x, y, paintCanvas);

    if (!this.preserveOnClick) {
      this.setPanel(undefined);
    }

    this.setPreserve(false);

    return true;
  }

  mouseMove(
    x: number,
    y: number,
    results: {
      kill: boolean;
      repaint: boolean;
      mousePointerChangeTo?: MousePointer;
    }
  ): void {
    if (!this.panel) return;

    // pass along to the panel if mouseMove is within panel's bounds
    if (
      x >= this.panel.viewportX &&
      y >= this.panel.viewportY &&
      x <= this.panel.viewportX + this.panel.viewportW &&
      y <= this.panel.viewportY + this.panel.viewportH
    ) {
      this.panel.mouseMove(x, y, results);
    }
  }

  setPanel(panel: BasicObject | undefined): void {
    this.panel = panel;
  }

  hasPanel(): boolean {
    return this.panel != undefined;
  }

  clear(): void {
    this.setPanel(undefined);
    this.setPreserve(false);
  }

  setPreserve(b: boolean): void {
    this.preserveOnClick = b;
  }

  setLocation(viewportX: number, viewportY: number): void {
    if (!this.panel) return;
    this.panel.viewportX = viewportX;
    this.panel.viewportY = viewportY;
  }
}

export const floater = new FloaterManager();
